module.exports = __webpack_public_path__ + "static/media/leading-mental-health-large@2x.569dc502.png";